var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import styled from '../../../../styles/styled';
import { CloseButton, } from '../../../CloseButton/CloseButton';
import { isArray } from '../../../../util/type-check';
const baseStyles = ({ theme }) => css `
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${theme.spacings.giga};
`;
const noHeadlineStyles = ({ children }) => isArray(children) &&
    !children[0] &&
    css `
    justify-content: flex-end;
  `;
const CardHeaderContainer = styled('header')(baseStyles, noHeadlineStyles);
const closeButtonStyles = ({ theme }) => css `
  margin-top: -${theme.spacings.byte};
  margin-right: -${theme.spacings.mega};
  margin-bottom: -${theme.spacings.byte};
`;
const CardHeaderCloseButton = styled(CloseButton)(closeButtonStyles);
/**
 * Header used in the Card component. Used for styling and alignment
 * purposes only.
 */
export const CardHeader = (_a) => {
    var { onClose, children, closeButtonLabel, tracking } = _a, props = __rest(_a, ["onClose", "children", "closeButtonLabel", "tracking"]);
    return (_jsxs(CardHeaderContainer, Object.assign({}, props, { children: [children, onClose && closeButtonLabel && (_jsx(CardHeaderCloseButton, { onClick: onClose, label: closeButtonLabel, tracking: tracking ? Object.assign({ component: 'close-button' }, tracking) : undefined }))] })));
};
